import { BarcodeNavigator } from './BarcodeNavigator';
import { AddWedgeScannerListener, BarcodeWedgeScannerListener } from './KeyboardWedgeScanner';

function useBarcodeScanner() {
  /**
   * AddWedgeScannerListener will ensure that only one event listener on the initial key is happening at the one time,
   * until isListeningForWedgeScan is off.
   */
  AddWedgeScannerListener();
  /**
   * BarcodeWedgeScannerListener is performing the listening of keys of which the keyboard wedge scanner is writing in.
   */
  BarcodeWedgeScannerListener();
  /**
   * The navigator that listens for the evaluted barcode response and navigates to the required page in the web app
   */
  BarcodeNavigator();
}

export { useBarcodeScanner };
